<template>
  <div class="pp-crumb">
    <NuxtLink :to="'/explore'">{{ t('property.crumb.projects') }}</NuxtLink>
    <span
      v-if="developerLabel"
      class="sep"
      >/</span
    >
    <span
      v-if="developerLabel"
      class="font-mono"
      >{{ developerLabel }}</span
    >
    <span
      v-if="title"
      class="sep"
      >/</span
    >
    <span
      v-if="title"
      class="cur"
      >{{ title }}</span
    >
  </div>
</template>

<script setup lang="ts">
const { title = '', developerLabel = '' } = defineProps<{
  title?: string;
  developerLabel?: string;
}>();

const { t } = useI18n();
</script>

<style scoped lang="scss">
.pp-crumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'JetBrains Mono', ui-monospace, monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(13, 15, 21, 0.62);
  font-weight: 600;

  .sep {
    color: rgba(13, 15, 21, 0.4);
  }

  a {
    color: rgba(13, 15, 21, 0.62);
    text-decoration: none;
    transition: color 0.15s ease;

    &:hover {
      color: #0d0f15;
    }
  }

  .cur {
    color: #0d0f15;
  }
}
</style>
